app.service('subscriptionPayments', function (accountConfig, lazyLoad, subscriptionWarranties, subscriptionServices, subscriptionOverduePayment, subscriptionResignForm) {

	let $self, $tabs, $tabsContent;
	let activeTab = 'warranties';
	let config, hasOverdueWarrantyPayments, hasOverdueServicePayments;

	function init() {
		setElements();
		setEvents();
		if (window.location.hash === "#uslugi") {
			activeTab = 'services';
			loadServices();
		} else {
			activeTab = 'warranties';
			loadWarranties();
		}

		subscriptionWarranties.init({
			onPageChange: loadWarranties
		})
		subscriptionServices.init({
			onPageChange: loadServices
		});

		subscriptionOverduePayment.init();
		subscriptionResignForm.init();
	}

	function setElements() {
		$self = $('#subscription-payment-list');
		$tabs = $self.find('.tab');
		$tabsContent = $self.find('.tabs-content');
		config = accountConfig.getData();
		hasOverdueWarrantyPayments = config.warrantyRecurringPaymentId !== '';
		hasOverdueServicePayments = config.serviceRecurringPaymentId !== '';
	}

	function setEvents() {
		$self
			.on('click', '.js-show-subscription-warranties', handleShowSubscriptionWarrantiesClick)
			.on('click', '.js-show-subscription-services', handleShowSubscriptionServicesClick);
	}

	function handleShowSubscriptionWarrantiesClick(e) {
		e.preventDefault();

		if (activeTab === $(this).data('type')) return;

		activeTab = $(this).data('type');
		loadWarranties();
	}

	function handleShowSubscriptionServicesClick(e) {
		e.preventDefault();

		if (activeTab === $(this).data('type')) return;

		activeTab = $(this).data('type');
		loadServices();
	}

	function loadWarranties(pageNumber = 0) {

		$tabsContent.addClass('loading');
		fetchSubscriptionWarranties(pageNumber)
			.then(fillActiveTab)
			.then(showWarrantySubscriptionDetails)
			.fail(() => {
				onError();
			})
			.always(() => {
				$tabsContent.removeClass('loading');
				renderActiveTab();
			});
	}

	function loadServices(pageNumber = 0) {

		$tabsContent.addClass('loading');
		fetchSubscriptionServices(pageNumber)
			.then(fillActiveTab)
			.then(showServiceSubscriptionDetails)
			.fail(() => {
				onError();
			})
			.always(() => {
				$tabsContent.removeClass('loading');
				renderActiveTab();
			});
	}

	function fetchSubscriptionWarranties(pageNumber) {
		let data = {
			pageNumber: pageNumber
		};
		if (hasOverdueWarrantyPayments) {
			data.recurringPaymentId = config.warrantyRecurringPaymentId; // // pokaże nieopłaconą gwarancję jako pierwszą na liście
		}
		return $.ajax({
			url: '/customer-warranty-subscription-list.ltr',
			data
		});
	}

	function fetchSubscriptionServices(pageNumber) {
		let data = {
			pageNumber: pageNumber
		};
		if (hasOverdueServicePayments) {
			data.recurringPaymentId = config.serviceRecurringPaymentId; // pokaże nieopłaconą usługę jako pierwszą na liście
		}

		return $.ajax({
			url: '/customer-subscription-service-contract-list.ltr',
			data
		});
	}

	function showWarrantySubscriptionDetails() {
		if (hasOverdueWarrantyPayments) {
			subscriptionWarranties.showSubscriptionDetails(config.warrantyRecurringPaymentId);
			hasOverdueWarrantyPayments = false;
		}
	}

	function showServiceSubscriptionDetails() {
		if (hasOverdueServicePayments) {
			subscriptionServices.showSubscriptionDetails(config.serviceRecurringPaymentId);
			hasOverdueServicePayments = false;
		}
	}

	function renderActiveTab() {
		$tabs
			.removeClass('is-active')
			.filter(function () {
				return $(this).data('type') === activeTab
			})
			.addClass('is-active');

		getActiveTabContent()
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');

		$.scrollTo($self);
		lazyLoad.update();
	}

	function fillActiveTab(html) {

		if (html.trim() === "") return;

		getActiveTabContent().html(html);
	}

	function onError(message = "Błąd ładowania zakładki.") {
		getActiveTabContent().text(message);
	}

	function getActiveTabContent() {
		return $tabsContent.find('.tab-content')
			.filter(function () {
				return $(this).data('type') === activeTab
			});
	}

	return {init};
});